import type { JSX } from 'react'
export interface PageSectionProps {
  children?: JSX.Element
  className?: string
}

export default function PageSection({ children, className }: PageSectionProps) {
  return (
    <section className={className}>
      <div className="max-w-[1680px] mx-auto px-6">{children}</div>
    </section>
  )
}
